import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

class SubscriptionStore extends BaseStore {
  static storeName = 'SubscriptionStore';

  static handlers = {
    UPDATE_SUBSCRIPTION(subscription: $TSFixMe) {
      const { id } = subscription;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'subscriptions' does not exist on type '{... Remove this comment to see the full error message
      this.subscriptions[id] = subscription;

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ UP... Remove this comment to see the full error message
      this.emitChange();
    },

    UPDATE_SUBSCRIPTION_FAILED(errorMessage: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'errorMessage' does not exist on type '{ ... Remove this comment to see the full error message
      this.errorMessage = errorMessage;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ UP... Remove this comment to see the full error message
      this.emitChange();
    },
  };

  subscriptions = {};

  errorMessage = null;

  hasLoaded() {
    return true;
  }

  hasError() {
    return !!this.errorMessage;
  }

  getSubscription(forumSubscriptionId: $TSFixMe) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return this.subscriptions[forumSubscriptionId];
  }

  getIsSubscribed(forumSubscriptionId: $TSFixMe) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const subscription = this.subscriptions[forumSubscriptionId];
    return !!subscription && subscription.isSubscribed;
  }

  getIsSubscriptionInProgress(forumSubscriptionId: $TSFixMe) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const subscription = this.subscriptions[forumSubscriptionId];
    return !!subscription && subscription.isInProgress;
  }
}

export default SubscriptionStore;
